import Image from 'next/image'

import { cn } from '@/lib/utils'

interface LogoProps {
    className?: string
    size?: 'sm' | 'md'
    priority?: boolean
}

const sizes = {
    sm: 'h-7 w-auto',
    md: 'h-9 w-auto'
}

export const Logo = ({ className, size = 'sm', priority = false }: LogoProps) => (
    <Image
        src='/modulify-ai-logo-maker.svg'
        alt='Modulify AI Logo Maker'
        width={123}
        height={34}
        className={cn(sizes[size], className)}
        priority={priority}
    />
)

export default Logo
